import { useCallback } from 'react'

/**
 * Hook for handling click-outside-to-close behavior on modal overlays
 *
 * Returns a click handler that triggers onClose only when clicking
 * directly on the overlay element (not its children/content).
 *
 * Uses event.target === event.currentTarget to distinguish
 * overlay clicks from content clicks.
 *
 * @param {Function} onClose - Callback to execute when overlay is clicked
 * @param {boolean} [enabled=true] - Whether the handler is active
 * @returns {Function} Click handler to attach to overlay element
 */
export function useClickOutside (onClose, enabled = true) {
  const handleOverlayClick = useCallback((event) => {
    if (!enabled) return
    if (typeof onClose !== 'function') return

    // Only trigger if clicking directly on overlay, not on modal content
    if (event.target === event.currentTarget) {
      onClose()
    }
  }, [onClose, enabled])

  return handleOverlayClick
}
